import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isLoaded, isEmpty } from 'react-redux-firebase';

const normalizeSubmission = (submission, submissionId) => {
  const title = (
    // Submission Title
    submission.title ||
    // First narration title
    (
      Array.isArray(submission.narrations) &&
      submission.narrations.length > 0 &&
      submission.narrations[0].title
    ) ||
    // No title
    "New submission"
  );

  return {
    id: submissionId,
    createdAt: submission?.createdAt?.toDate(),
    voice: submission.voice,
    contentType: submission.contentType,
    contentLink: submission.contentType === 'url' ? submission.contentUrl : submission.contentFileUrl,
    contentUrl: submission.contentUrl,
    contentFileUrl: submission.contentFileUrl,
    contentEdit: submission.contentEdit,
    contentEditUrl: submission.contentEditUrl,
    title: title,
    narrations: submission.narrations,
    userId: submission.userId,
    status: submission.status,
    notes: submission.notes,
    unauthName: submission.name,
    unauthEmail: submission.email
  };
}

export const useSubmissionSelector = (submissionId) => {
  return useSelector((state) => {
    const submissions = state.firestore?.data?.submissions;

    // not loaded
    if (!submissions) {
      return undefined;
    }

    // empty
    if (!submissions[submissionId]) {
      return {};
    }

    return normalizeSubmission(submissions[submissionId], submissionId);
  });
}

export const useSubmissionsSelector = () => {
  return useSelector((state) => {
    const submissions = state.firestore?.ordered?.submissions;

    return submissions && submissions
      .filter(submission => !!submission)
      .map(submission => normalizeSubmission(submission, submission.id));
  });
}

export const useLazyIsAdmin = () => {
  const profile = useSelector(state => state.firebase.profile)
  return isLoaded(profile) && ! isEmpty(profile) && profile.isAdmin
}

export const useBodyClass = (className) => {
  const addBodyClass = className => document.body.classList.add(className);
  const removeBodyClass = className => document.body.classList.remove(className);

  useEffect(
    () => {
      // Set up
      className instanceof Array ? className.map(addBodyClass) : addBodyClass(className);

      // Clean up
      return () => {
          className instanceof Array
              ? className.map(removeBodyClass)
              : removeBodyClass(className);
      };
    },
    [className]
  );
}
